<template>
  <Popup :width="width" :top="top" :closePopupEvent="closePopupCB">
    <div slot="header">
      <h6>Edit Profile</h6>
    </div>
    <div class="session-exp-popup">
      <div class="edit-profile-image">
        <div class="edit-profile-img-responsive">
          <img v-if="picture && !userProfile" :src="picture" alt="vlt-prof" class="main-profile" />
          <img v-else :src="defaultPicture" alt="vlt-prof" class="main-profile" />

          <div
            class="camera-img"
            :style="{
                'transform': formError ? 'translateY(-10%)' : 'translateY(0%)'
              }"
          >
            <input
              type="file"
              id="selectfile"
              accept="image/*"
              :value="fileInput"
              @change="(e) => inpFileChangeCB(e)"
            />
            <img @click="trigger()" src="@/assets/icons/camera.svg" />
          </div>
        </div>

        <!-- <img
            v-if="picture"
            :src="picture"
            alt="vlt-prof"
             />
          <img
            v-else
            :src="defaultPicture"
            alt="vlt-prof"
        class="edit-profile-img-responsive" />-->

        <!-- <div @click="openEditProfilePopup" class="profile-edit">
              <img src="@/assets/icons/edit.png"/>
            <span>Edit</span>
        </div>-->
      </div>

      <FormError v-show="formError" :message="formError" style="margin: 2% 0;"></FormError>
      <div class="signup-form">
        <!-- Form -->
        <form @submit.prevent="editProfileCB" autocomplete="off">
          <input autocomplete="false" name="hidden" type="text" style="display:none;" />

          <div class="vlt-signup-form">
            <!-- Name Input -->
            <div class="vlt-input-group">
              <label class="login-label">Name</label>
              <input
                id="subscribername"
                type="text"
                v-model="subscribername"
                placeholder
                ref="subscribername"
                maxlength="64"
              />
              <p class="signup-error-message">{{ subscribernameError }}</p>
            </div>

            <!-- Email Input -->
            <div class="vlt-input-group">
              <label class="login-label">Email</label>
              <input
                ref="userEmail"
                id="userEmail"
                type="text"
                v-model="userEmail"
                placeholder
                maxlength="128"
                :disabled="userEmail ? true : false"
              />
              <p class="signup-error-message">{{ userEmailError }}</p>
            </div>
            <!-- Date Of Birth format--MMM Do YY-->
            <div class="vlt-input-group">
              <label class="login-label">Date Of Birth</label>
              <div class="vlt-input">
                <VueDatepicker
                  v-model="dob"
                  :first-day-of-week="1"
                  :editable="false"
                  lang="en"
                  width="100%"
                  format="DD-MM-YYYY"
                  placeholder
                  :not-after="new Date()"
                  id="inp-dob"
                  ref="inp-dob"
                  :disabled="dobPresent"
                  style="font-size: 18px;"
                ></VueDatepicker>
                <img class="calender-img" src="@/assets/icons/Ic_calendar.svg" />
              </div>
            </div>

            <!-- Gender Radio -->
            <div class="subs-gender">
              <h6 class="gender-label">Gender</h6>
              <div
                class="vlt-radio inline"
                :style="{
                    'cursor': genderPresent ? 'not-allowed' : 'pointer'
                  }"
              >
                <input
                  id="subs-gender-1"
                  name="radio"
                  type="radio"
                  checked
                  v-model="gender"
                  value="MALE"
                  ref="user-gender"
                  :disabled="genderPresent ? true : false"
                />
                <label
                  for="subs-gender-1"
                  class="radio-label"
                  :style="{
                        'cursor': genderPresent ? 'not-allowed' : 'pointer'
                      }"
                >Male</label>
              </div>
              <div class="vlt-radio inline">
                <input
                  id="subs-gender-2"
                  name="radio"
                  type="radio"
                  v-model="gender"
                  value="FEMALE"
                  ref="user-gender"
                  :disabled="genderPresent ? true : false"
                />
                <label
                  for="subs-gender-2"
                  class="radio-label"
                  :style="{
                        'cursor': genderPresent ? 'not-allowed' : 'pointer'
                      }"
                >Female</label>
              </div>
              <div class="vlt-radio inline">
                <input
                  id="subs-gender-3"
                  name="radio"
                  type="radio"
                  v-model="gender"
                  value="OTHER"
                  :disabled="genderPresent ? true : false"
                />
                <label
                  for="subs-gender-3"
                  class="radio-label"
                  ref="user-gender"
                  :style="{
                        'cursor': genderPresent ? 'not-allowed' : 'pointer'
                      }"
                >Other</label>
              </div>
            </div>

            <!-- Buttons -->
            <div class="vlt-signup-btns" style="margin-top:10%;">
              <button type="submit" class="btn-lg-primary" ref="submitBtn">Update</button>
            </div>
          </div>
        </form>
      </div>
      <Loading v-show="showLoading"></Loading>
    </div>
  </Popup>
</template>

<script>
import Utility from "@/mixins/Utility";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { EventBus } from "@/main";

export default {
  name: "EditProfile",
  data() {
    return {
      width: "35%",
      top: "50%",
      subscribername: "",
      userEmail: "",
      phoneNumber: null,
      gender: "",
      dob: "",
      fileName: null,
      userProfile: null,
      defaultPicture: require("@/assets/icons/user-black.png"),
      showLoading: false,
      formError: "",
      fileInput: null,
      genderPresent: false,
      // error
      subscribernameError: "",
      userEmailError: "",
      subscriberphoneNumberError: ""
    };
  },
  props: ["closePopupCB"],
  components: {
    Popup: () => import("@/components/Slots/Popup.vue"),
    Loading: () => import("@/components/Templates/Loading.vue"),
    FormError: () => import("@/components/Templates/FormError.vue"),
    VueDatepicker: () => import("vue2-datepicker")
  },
  computed: {
    ...mapGetters(["subscriberid", "picture", "AppUser", "country"])
  },
  watch: {
    formError(value) {
      if (value) {
        setTimeout(() => {
          this.formError = null;
        }, 5000);
      }
    }
  },
  created() {
    this.initEditProfilePopup();
  },
  beforeDestroy() {},
  methods: {
    ...mapActions([
      "actUpdateSubscriber",
      "actGetSubscriber",
      "actUploadImage"
    ]),
    trigger() {
      $("#selectfile").trigger("click");
    },
    inpFileChangeCB(event) {
      this.formError = "";
      let file = event.target.files[0];
      if (!file) return;
      let filetype = file.type;
      let validImageTypes = ["image/gif", "image/jpeg", "image/png"];

      let size = Math.round(file.size / 1000);
      if (!validImageTypes.includes(filetype)) {
        this.formError = "Not a valid image type";
        return;
      } else if (size > 100) {
        this.formError = "File size exceeded limit: 100kb";
        return;
      } else {
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = () => {
          if (img.width < 256 || img.height < 256) {
            this.formError = "Invalid File width/height";
            return;
          }
        };
        img.src = _URL.createObjectURL(file);
        this.defaultPicture = _URL.createObjectURL(file);
        // console.log("defaultPicture", this.defaultPicture);
        this.userProfile = file;
      }
    },
    initEditProfilePopup() {
      this.subscribername = this.AppUser.subscribername;
      this.userEmail = this.AppUser.email;
      this.dob = this.AppUser.dob;
      this.phoneNumber = this.AppUser.contactno;
      this.dobCopy = this.AppUser.dob;
      this.gender = this.AppUser.gender ? this.AppUser.gender : "";
      this.genderPresent = this.AppUser.gender ? true : false;
      this.dobPresent = this.AppUser.dob ? true : false;
    },
    closePopup() {
      // Hide the popup
      this.closePopupCB();
    },
    editProfileCB() {
      this.formError = "";
      if (!this.isFormValid()) return;
      if (this.userProfile) {
        this.changeUserProfile(this.changeUserData);
      } else {
        this.changeUserData();
      }
    },
    changeUserProfile(callback = null) {
      this.actUploadImage(this.userProfile)
        .then(response => {
          if (response.success) {
            this.fileName = response.success;
            if (callback) callback();
          } else {
            this.formError = response.reason;
          }
        })
        .catch(error => {});
    },
    updateSubscriberData() {
      this.actGetSubscriber({
        email: this.userEmail
      })
        .then(response => {
          let AppUser = {
            ...this.AppUser,
            ...response
          };
          localStorage.setItem("AppUser", JSON.stringify(AppUser));

          this.$store.commit("CommitUserStore");
          this.closePopup();
        })
        .catch(error => {});

      this.showLoading = false;
    },
    changeUserData() {
      // If no subscriberid, return
      if (!this.subscriberid) return;

      let data = {
        subscribername: this.subscribername,
        country: this.country,
        email: this.userEmail
      };
      if (this.gender) {
        data.gender = this.gender;
      }
      if (this.fileName) {
        data.picture = this.fileName;
      }
      if (this.dob) {
        let dobCopy = new Date(this.dob);
        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/ false || !!document.documentMode;

        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;
        if (isEdge) {
          if (this.dob !== this.dobCopy) {
            dobCopy.setDate(dobCopy.getDate() + 1);
            data.dob = new Date(`${dobCopy}`).toISOString().slice(0, 10);
          }
        } else {
          data.dob = new Date(`${dobCopy}EDT`).toISOString().slice(0, 10);
        }
      }
      // Show Loding
      this.showLoading = true;
      // Disable the submit button
      this.$refs.submitBtn.disabled = true;

      this.actUpdateSubscriber(data)
        .then(response => {
          // Check for error in response
          if (response.error) {
            this.formError = response.reason;

            this.showLoading = false;
            // Enable the submit button
            this.$refs.submitBtn.disabled = false;
          } else {
            this.updateSubscriberData();
          }
        })
        .catch(error => {
          // Hide the Loader
          this.showLoading = false;
          // Enable the submit button
          this.$refs.submitBtn.disabled = false;
          // Show the appropriate message
          this.formError = "Oops! Something error happened";
        });
    },
    isFormValid() {
      return this.validateName() && this.validateEmailInput();
      // && this.validateDOB();
    },
    validateDOB() {
      if (this.dob) {
        let today = new Date();
        let birthDate = new Date(this.dob);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 18) {
          this.formError = "You must me 18+ to access this website.";
          return false;
        }
        return true;
      }
    },
    validateName() {
      let minChar = 3;
      let maxChar = 64;

      if (!this.subscribername) {
        this.subscribernameError = "Please enter Name";
        document.getElementById("subscribername").classList.add("formError");
        return false;
      } else if (!this.validateInputName(this.subscribername)) {
        this.subscribernameError = `Please enter valid name.`;
        document.getElementById("subscribername").classList.add("formError");
        return false;
      } else if (this.subscribername.length < minChar) {
        this.subscribernameError = `Name should contain atleast ${minChar} characters`;
        document.getElementById("subscribername").classList.add("formError");
        return false;
      } else if (this.subscribername.length > maxChar) {
        this.subscribernameError = `Name should be less than ${maxChar} characters`;
        document.getElementById("subscribername").classList.add("formError");
        return false;
      } else {
        this.subscribernameError = "";
        document.getElementById("subscribername").classList.remove("formError");
        return true;
      }
    },
    validateEmailInput() {
      let maxChar = 128;
      // validateEmail method was defined in Utility mixin
      if (!this.userEmail) {
        this.userEmailError = "Please enter Email";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (!this.validateEmail(this.userEmail)) {
        this.userEmailError =
          "Invalid Email Id.Please enter in format xxx@yyy.com";
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else if (this.userEmail.length > maxChar) {
        this.userEmailError = `E-mail must be less than ${maxChar} characters`;
        document.getElementById("userEmail").classList.add("formError");
        return false;
      } else {
        this.userEmailError = "";
        document.getElementById("userEmail").classList.remove("formError");
        return true;
      }
    }
  },
  mixins: [Utility]
};
</script>

<style lang="scss" scoped>
@import "~sass/modules/variables";
#inp-dob {
  .mx-input-wrapper {
    .mx-input {
      font-size: 18px !important;
      font-weight: 400;
      opacity: 0.5;
      color: #212121;
      padding: 0;
    }
  }
}
.vlt-input-group input[type="text"] {
  font-size: 18px !important;
  font-weight: 400;
  opacity: 0.5;
  color: #212121;
}

input {
  caret-color: #4558dd;
  width: 2px;
  font-size: 18px;
  font-weight: 400;
  opacity: 0.5;
  color: #212121;
  &:disabled {
    cursor: not-allowed;
  }
}
.calender-img {
  float: right;
  margin-top: -8%;
  margin-right: 10px;
}
.session-exp-popup {
  padding: 20px;
}
.login-logo {
  text-align: center;
  img {
    width: 20%;
  }
}
.signup-form {
  margin: 0 10% 0 10%;
}
.vlt-input-group {
  margin: 0 0 10px 0;
  input[type="number"] {
    border: 0;
    border-bottom: 2px solid black;
    font-size: 14px;
    height: 40px;
    width: 100%;
    background-color: transparent;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }
  }
}
.vlt-signup {
  padding: 20px;

  :nth-child(1) {
    margin-left: 30%;
  }
  :nth-child(2) {
    margin-left: 10px;
    cursor: pointer;
    font-weight: 600;
  }
  p {
    color: $font-clr-black;
    float: left;
  }
}
.login-label {
  color: #212121;
  font-family: "ProximanovaBold";
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
}
.signup-error-message {
  color: #d0021b;
  font-family: "HelveticaNeue";
  font-size: 16px;
  font-weight: 100;
  line-height: 18px;
  margin-top: 5px;
}
.edit-profile-image {
  margin: 0 10% 0 10%;
  text-align: center;
  // img:first-child{
  //   width: 100px;
  //   border-radius: 50%;
  // }

  .edit-profile-img-responsive {
    width: 100px;
    height: 100px;
    /* text-align: center; */
    margin: 0 auto;
    border-radius: 50%;
    cursor: pointer;
    background-size: cover;
    .main-profile {
      width: 100px;
      height: 100px;
      border-radius: 50%;
    }
    &:hover {
      .camera-img {
        opacity: 1;
        transition: all 0.3s ease;
        transform: translateY(0%);
      }
    }
  }
}
.camera-img {
  position: absolute;
  // right: 39.5%;
  top: 15%;
  height: 100px;
  width: 100px;
  text-align: center;
  background: rgba(0, 0, 0, 0.26);
  border-radius: 50%;
  transform: translateY(-80%);
  transition: all 0.3s ease;
  opacity: 0;
  cursor: pointer;
  img {
    position: relative;
    width: 25px;
    top: 32%;
  }
}
.subs-gender {
  margin: 20px 0 15px;
  .gender-label {
    display: inline-block;
    margin-right: 35px;
    color: #212121;
    font-family: "ProximanovaBold";
    font-size: 18px;
    line-height: 22px;
  }
  label {
    opacity: 0.7;
    color: #212121;
    font-family: "ProximanovaBold";
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
  }
  .radio-label {
    padding-left: 22px;
  }
}
// Radio Button
.vlt-radio {
  position: relative;
  &.inline {
    display: inline-block;
    margin-right: 15px;
  }
  input {
    opacity: 0;
    position: absolute;
    &:checked {
      + label::before {
        border: 1.5px solid black;
      }
      + label::after {
        width: 10px;
        height: 10px;
        left: 4px;
        top: 4px;
        border-radius: 50%;
        background-color: #4558dd;
      }
      + label {
        opacity: 1;
        font-weight: bold;
        color: black;
      }
    }
  }
  label {
    position: relative;
    padding-left: 20px;
    font-weight: 300;
    &::before,
    &::after {
      position: absolute;
      content: "";
    }
    &::before {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      left: 0;
      top: 0;
      border: 1px solid #484848;
      border-color: black;
    }
  }
}
input[type="file"] {
  position: relative;
  top: 40%;
  display: none;
  z-index: 100;
}
.vlt-input {
  .mx-input {
    padding: 0 !important;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .camera-img {
    opacity: 1;
    // right: 34%;
    top: 10%;
  }
  .calender-img {
    float: right;
    margin-top: -13%;
  }
  .vlt-radio {
    position: relative;
    &.inline {
      margin: 10px 0;
      display: block;
    }
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
// 4k
@media screen and (min-width: 1900px) {
  .camera-img {
    left: 43%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Popups/EditProfile.vue